import type { FC } from 'react';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Help from '@mui/icons-material/Help';
import { Button, Stack, Typography } from '@mui/material';

import Modal from 'src/components/common/Modal';

import { styles } from './index.styles';

export const FI_ADDITIONAL_INFO_TEST_ID = 'fi-additional-info';

const ButtonAdditionalInfoModal: FC = () => {
  const { t } = useTranslation('followUpInspirations');
  const [showModal, setShowModal] = useState(false);
  const handleClick = () => setShowModal((prevState) => !prevState);
  return (
    <>
      <Button
        color="inherit"
        variant="text"
        endIcon={<Help color="primary" />}
        onClick={handleClick}
        data-test-id={FI_ADDITIONAL_INFO_TEST_ID}
        sx={styles.button}
      >
        {t('followUpInspirations:instructions')}
      </Button>
      <Modal isOpen={showModal} onClose={handleClick}>
        <Stack spacing={2}>
          <Typography component="p">
            <Trans
              i18nKey="followUpInspirations:InstructionsText.instructions1"
              components={{
                b: <b />,
                span: <span style={{ textDecoration: 'underline' }} />,
              }}
            />
          </Typography>
          <Typography component="p">
            <Trans
              i18nKey="followUpInspirations:InstructionsText.instructions2"
              components={{
                b: <b />,
                span: <span style={{ textDecoration: 'underline' }} />,
              }}
            />
          </Typography>
          <Typography component="p">
            <Trans
              i18nKey="followUpInspirations:InstructionsText.instructions3"
              components={{
                b: <b />,
                span: <span style={{ textDecoration: 'underline' }} />,
              }}
            />
          </Typography>
        </Stack>
      </Modal>
    </>
  );
};

export default ButtonAdditionalInfoModal;
